import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Copyright: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M14.83 14.83a4 4 0 1 1 0-5.66' }],
  ],
];

export default Copyright;
